"use client";

import dynamic from "next/dynamic";

// Dynamically import heavy/animated components, disable SSR
const DynamicBackgroundGlow = dynamic(
  () => import("./BackgroundGlow").then((mod) => mod.BackgroundGlow),
  { ssr: false }
);

const DynamicAnimatedAppIcon = dynamic(
  () => import("./AnimatedAppIcon").then((mod) => mod.AnimatedAppIcon),
  { ssr: false }
);

const DynamicWaveLines = dynamic(
  () => import("@/app/components/WaveLines").then((mod) => mod.WaveLines),
  { ssr: false }
);

export function HeroVisuals() {
  return (
    <>
      {/* Background elements - Dynamically Loaded */}
      <DynamicBackgroundGlow />

      {/* App Icon - Hidden on mobile, shown md and up */}
      <div className="hidden md:block">
        <DynamicAnimatedAppIcon />
      </div>

      {/* Wave Lines - Hidden on mobile, shown md and up */}
      <div className="hidden md:block absolute top-1/2 right-0 w-[50%] transform -translate-y-1/2 translate-x-[45%] z-10">
        <DynamicWaveLines />
      </div>
      <div className="hidden md:block absolute top-1/2 right-0 w-[50%] transform -translate-y-1/2 -translate-x-[70%] -scale-x-100 z-10 opacity-50">
        <DynamicWaveLines />
      </div>
    </>
  );
}
